import _ from "lodash";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import API from "../app/api";
import {user} from "../store/reducers/user";

export default function useConsultantsDict(consultantsForm, consultantType, filterBy, sortBy) {
    const controller = new AbortController();
    const userObject = useSelector(user);

    const [list, setList] = useState([]);
    const [findUser, setFindUser] = useState(null);
    //console.log(consultantType)

    const getConsultants = async () => {
        const tempList = [];
        const consultantArray = JSON.stringify([consultantsForm]);
        let filterLocal = `deactivated ne true and availableIn ne null`;

        if (consultantsForm && !consultantType) {
            filterLocal += ` and availableIn in '${consultantArray}'`
        }
        if (consultantType) {
            // filterLocal += ` and consultantType eq '${consultantType}'`
            filterLocal = `deactivated ne true and consultantType eq '${consultantType}'`
        }
        if (filterBy && filterBy !== "") {
            filterLocal = `(${filterBy} eq true and deactivated ne true and availableIn ne null and availableIn in '${consultantsForm}')`;
            if (consultantType) {
                filterLocal += `(${filterBy} eq true and deactivated ne true and consultantType eq '${consultantType}'`
            }
        }
        //console.log(filterLocal);
        await API.getDictByURL(`/consultants?$filter=${encodeURIComponent(`${filterLocal}`)}&$sort=${sortBy ? sortBy : 'familyName'}&$pageSize=10&$page=1`, controller.signal)
            .then(dictData => {
                if (!_.isEmpty(dictData?.__data)) {
                    _.forEach(dictData?.__data, element => {
                        // if (element.availableIn.includes(consultantsForm)) {
                        if (element.userName === userObject?.userName) {
                            setFindUser(element);
                        }
                        tempList.push({
                            ...element,
                            group: "Consultants"
                        });
                        // }
                        // }
                    });
                }
            });

        setList(tempList);
    }

    useEffect(() => {
            getConsultants();
            return () => {
                controller.abort();
            };
        },[]
    );

    return [list, findUser];
}